export default __webpack_public_path__ + "static/media/car.inline.5dda0c04.svg";